<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="6"
                lg="10"
                md="8"
                sm="6"
            >
                <h3>Work Order Request</h3>
            </v-col>
            <v-col 
                style="text-align: right;"
                cols="6"
                lg="2"
                md="4"
                sm="6"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn 
                            v-bind="attrs"
                            v-on="on"
                            :to="{ name: 'workOrderRequestForm', params: { id: 0 } }"
                        >
                            New
                        </v-btn>
                    </template>
                    <span>New Work Order Request</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Quick Search"
                        prepend-inner-icon="mdi mdi-magnify"
                        outlined
                        single-line
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
        </v-row>
        <v-row>
            <v-col 
                cols="12"
                lg="2"
                md="6"
                sm="12"
            >
                <label>Status</label>
                <v-combobox
                    v-model="filter.statusSelected"
                    :items="listStatus" 
                    item-text="statusDescription"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterRegisters()"
                ></v-combobox>
            </v-col>
            <v-col 
                cols="6"
                lg="3"
                md="6"
                sm="6"
            >
                <v-menu
                    ref="mnuTargetDateStart"
                    v-model="mnuTargetDateStart"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Target Date Start</label>
                        <v-text-field
                            v-model="filter.targetDateStartFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.targetDateStart"
                        no-title
                        @input="mnuTargetDateStart = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col 
                cols="6"
                lg="3"
                md="6"
                sm="6"
            >
                <v-menu
                    ref="mnuTargetDateEnd"
                    v-model="filter.mnuTargetDateEnd"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Target Date End</label>
                        <v-text-field
                            v-model="filter.targetDateEndFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.targetDateEnd"
                        no-title
                        @input="mnuTargetDateEnd = false"
                        :min="filter.targetDateStart"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="filteredSearch"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.statusDescription="{ item }">
                        <v-chip
                            :color="getStatusColor(item.status)"
                            outlined
                            dark
                        >
                            {{ item.statusDescription }}
                        </v-chip>
                    </template>

                    <template v-slot:item.targetDateFormatted="{ item }">
                        <label :style="item.targetDateExpired == 1 ? 'color: var(--color__red) !important; ' : ''">
                            {{ item.targetDateFormatted }}
                        </label>
                    </template>
                    
                    <template v-slot:item.action="{item}">
                        <ActionList 
                            :id="item.id" 
                            :link="'workOrderRequestForm'"
                            :showButtons="{
                                edit: item.status !== 2 && (item.status === 0 || item.status === 3 || isProfileAdmin) ? true : false,
                                delete: false,
                                cancel2: item.status == 0 ? true : false,
                                approve: item.status == 1 && isProfileAdmin ? true : false,
                                deny: item.status == 1 && isProfileAdmin ? true : false,
                                sendApprove: item.status == 0 ? true : false,
                                viewDetails: item.status == 3 ? true : false,
                                download: item.status !== 4 ? true : false
                            }"
                            @confirmCancel2="confirmCancel"
                            @confirmSendApprove="confirmSendApprove"
                            @confirmApprove="confirmApprove"
                            @confirmDeny="showDialogToDeny"
                            @confirmViewDetails="confirmViewDetails(item)"
                            @confirmDownload="confirmDownload"
                        />
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

        <v-dialog
            v-model="showDialogReason"
            transition="dialog-top-transition"
            persistent
            width="500"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Describe a reason
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>Reason</label>
                            <v-textarea
                                v-model="description"
                                single-line
                                rows="4"
                                row-height="30"
                                outlined
                                :disabled="reasonDisabled"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            v-if="!reasonDisabled"
                            class="mx-2 buttonCancelDialog v-btn-large"
                            outlined
                            @click="showDialogReason = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            v-if="!reasonDisabled"
                            class="mx-2 v-btn-large"
                            outlined
                            @click="confirmDeny()"
                        >
                            Confirm
                        </v-btn>

                        <v-btn 
                            v-if="reasonDisabled"
                            class="mx-2 dialogButtonDismiss v-btn-large"
                            @click="showDialogReason = false"
                        >
                            Dismiss
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import * as moment from 'moment';

    export default ({

        components: {
            ActionList,
            ActionDialog
        },

        mixins: [Helpers],

        data: vm => ({

            id: 0,
            statusId: 0,

            loading: false,

            filter: {
                fastSearch: '',
                statusSelected: null,
                targetDateStart: moment().clone().startOf('month').format('YYYY-MM-DD'),
                targetDateEnd: moment().clone().endOf('month').format('YYYY-MM-DD'),
                targetDateStartFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                targetDateEndFormatted: moment().clone().endOf('month').format('MM/DD/YYYY'),
            },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            headers: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Created By", value: "userNameRegister", sortable: true },
                { text: "Project", value: "projectDescription", sortable: true },
                { text: "Target Date", value: "targetDateFormatted", sortable: true },
                { text: "Responsibles", value: "usersNames", sortable: true },
                { text: "Finished On", value: "endDateFormatted", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            options: { rowsPerPage: 10, page: 1 },

            listWorkOrderRequest: [],
            listWorkOrderRequestFiltered: [],
            listStatus: [],

            mnuTargetDateStart: false,
            mnuTargetDateEnd: false,

            titleDate: '',
            todayDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            todayDateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            mnuTodayDate: false,

            showDialogReason: false,
            description: '',
            reasonDisabled: false,
        }),

        watch: {
            todayDate () {
                this.todayDateFormatted = this.formatDate(this.todayDate)
            },

            "filter.targetDateStart" () {
                this.filter.targetDateStartFormatted = this.formatDate(this.filter.targetDateStart)
                this.filterRegisters();
            },

            "filter.targetDateEnd" () {
                this.filter.targetDateEndFormatted = this.formatDate(this.filter.targetDateEnd)
                this.filterRegisters();
            },
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            filteredSearch: function() {
                return this.listWorkOrderRequestFiltered.filter((workOrderFilter) => {
                    
                    const filter = this.filter.fastSearch.toLowerCase();

                    const dateRegisterFormatted = workOrderFilter.dateRegisterFormatted.toLowerCase().match(filter)
                    const projectDescription = workOrderFilter.projectDescription.toLowerCase().match(filter)
                    const userNameRegister = workOrderFilter.userNameRegister.toLowerCase().match(filter)
                    const targetDateFormatted = workOrderFilter.targetDateFormatted.toLowerCase().match(filter)
                    const responsibleName = workOrderFilter.usersNames.toLowerCase().match(filter)
                    const id = workOrderFilter.id.toString().match(filter);

                    if(dateRegisterFormatted != null) { return dateRegisterFormatted; } 
                    else if(projectDescription != null) { return projectDescription; } 
                    else if(userNameRegister != null) { return userNameRegister; } 
                    else if(targetDateFormatted != null) { return targetDateFormatted; } 
                    else if(responsibleName != null) { return responsibleName; } 
                    else { return id; }
                });
            },

            isProfileAdmin() {
                return (this.userLoggedGetters.profile.systemAdmin != null && 
                        this.userLoggedGetters.profile.systemAdmin == 1) ||
                        (this.userLoggedGetters != null && this.userLoggedGetters.id == 0)
                
            },
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            parseDate (date) {
                if (!date) return null

                const [month, day, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    case 0:
                        color = 'var(--color__cinza_escuro)';
                        break;

                    case 1:
                        color = 'var(--color__status_pending)';
                        break;

                    case 2:
                        color = 'var(--color__main)';
                        break;

                    case 3:
                    case 4:
                        color = 'var(--color__red)';
                        break;

                    case 5:
                        color = 'var(--color__pipeline_waiting_approval)';
                        break;

                    default:
                        color = 'var(--color__main)';
                        break;
                }

                return color
            },

            async getRegisters() {
                this.listWorkOrderRequest = await this.$store.dispatch("workOrderRequestModule/List");
                this.listStatus = await this.$store.dispatch("workOrderRequestModule/ListStatus");
                await this.filterRegisters();
            },

            confirmCancel(id) {

                const textConfirmation = 'You will CANCEL this Work Order, confirm your decision?';
                this.statusId = 4;

                this.id = id;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: textConfirmation,
                    methodConfirm: this.updateStatus,
                    params: id
                };

            },

            confirmSendApprove(id) {

                const textConfirmation = 'You will SEND this Work Order Request for approval, confirm your decision?';
                this.statusId = 1;

                this.id = id;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: textConfirmation,
                    methodConfirm: this.updateStatus,
                    params: id
                };
            },

            confirmApprove(id) {

                const textConfirmation = 'You will APPROVE this Work Order Request and create a Work Order, confirm your decision?';
                this.statusId = 2;

                this.id = id;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: textConfirmation,
                    methodConfirm: this.updateStatus,
                    params: id
                };
            },

            showDialogToDeny(id) {
                this.id = id;
                this.reasonDisabled = false;
                this.showDialogReason = true;
            },

            confirmViewDetails(item) {
                this.id = item.id;
                this.description = item.reason;
                this.reasonDisabled = true;
                this.showDialogReason = true;
            },

            confirmDeny() {

                const textConfirmation = 'You will DENY this Work Order Request, confirm your decision?';
                this.statusId = 3;

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: textConfirmation,
                    methodConfirm: this.updateStatus,
                    params: this.id
                };
            },

            async updateStatus() {

                this.showLoading();

                const updateStatusRequest = {
                    id: this.id,
                    status: this.statusId,
                    description: this.description
                }

                const result = await this.$store.dispatch("workOrderRequestModule/UpdateStatus", updateStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getRegisters();
                this.showDialogReason = false;

                this.hideLoading();
            },

            async confirmDownload(id) {

                this.showLoading();

                this.$vanKirkApi.get(`workorder-request/download/${id}`, {
                        responseType: "blob",
                    })
                    .then((response) => {

                        var blob = new Blob([response.data], {
                            type: "application/pdf",
                        });

                        var url = window.URL.createObjectURL(blob);
                        window.open(url);

                        this.getRegisters();
                        this.hideLoading();
                    })
                    .catch(error => {
                        
                        let errorMessage = "";
                        if (error.response && error.response.status === 400) {
                            errorMessage = `Error to generate work order request: [${error.response.data}]`;
                        }
                        else {
                            errorMessage = `Error to generate work order request: [${error}]`;
                        }
                        
                        this.showToast("error", "Erro!", errorMessage);
                        this.hideLoading();
                    }
                );
            },

            async filterRegisters() {

                let idStatus = 0;
                let listFiltered = [...this.listWorkOrderRequest];

                if (this.filter.statusSelected != null && this.filter.statusSelected != undefined) {
                    idStatus = this.filter.statusSelected.id;
                    listFiltered = listFiltered.filter(wor => wor.status == idStatus);
                }

                if (this.filter.targetDateStart != null && this.filter.targetDateStart != undefined && 
                    this.filter.targetDateEnd != null && this.filter.targetDateEnd != undefined) {
                    listFiltered = listFiltered.filter(wor => (wor.targetDate >= this.filter.targetDateStart && wor.targetDate <= this.filter.targetDateEnd) || (wor.targetDate == null || wor.targetDate == undefined));
                }

                this.listWorkOrderRequestFiltered = listFiltered;
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        }
    })
</script>

<style scoped>
    .v-btn {
        height: 45px !important;
        width: 150px;
    }
</style>